import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { Q as vBoolean, a1 as vUndefOr, a as vString } from './validation-02b8d01d.js';
import './i18n-939e2dee.js';

const dsTabCss = "ds-tab{display:-ms-inline-flexbox;display:inline-flex}";

const DsTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.selectTab = createEvent(this, "selectTab", 7);
    this.propError = {};
    this.isSelected = false;
    this.index = null;
    this.isDisabled = false;
    this.padding = undefined;
    this.activeClassName = undefined;
    this.fontSize = undefined;
  }
  watchIsDisabled() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDisabled', 'boolean', vBoolean))
      return;
  }
  watchPadding() {
    /* istanbul ignore if */
    if (!propCheck(this, 'padding', 'string', vUndefOr(vString)))
      return;
  }
  watchActiveClassName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'activeClassName', 'string', vUndefOr(vString)))
      return;
  }
  watchFontSize() {
    /* istanbul ignore if */
    if (!propCheck(this, 'fontSize', 'string', vUndefOr(vString)))
      return;
  }
  async unselect() {
    this.isSelected = false;
  }
  async select() {
    this.isSelected = true;
  }
  connectedCallback() {
    runWatchers(this);
    const dsTabs = this.host.closest('ds-tabs');
    if (!dsTabs) {
      propCheck(this, '@slot', '<ds-tabs> as a parent element', () => 'Must be rendered inside <ds-tabs>');
      return;
    }
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h(Host, { role: "tab", class: this.isSelected ? (this.activeClassName ? this.activeClassName : 'active-tab') : '', style: { padding: this.padding && this.padding, fontSize: this.fontSize && this.fontSize } }, h("slot", null)));
  }
  get host() { return getElement(this); }
  static get watchers() { return {
    "isDisabled": ["watchIsDisabled"],
    "padding": ["watchPadding"],
    "activeClassName": ["watchActiveClassName"],
    "fontSize": ["watchFontSize"]
  }; }
};
DsTab.style = dsTabCss;

export { DsTab as ds_tab };
